import React, { useEffect, useState } from "react";
import classes from "./DocumentBoard.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { env } from "../../../constants/env";

const DocumentCard = ({
  title,
  refNo,
  planType,
  description,
  progress,
  link,
  isNew,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`card mb-3 ${classes.card}`}
      onClick={() => link && navigate(link)}
      style={{ cursor: link ? "pointer" : "default" }}
    >
      <div className="card-body position-relative">
        {isNew && <span className={classes.newTag}>NEW</span>}
        <h6 className="mb-3">{title}</h6>
        <p className={classes.typeText}>Ref# {refNo}</p>
        <p className={classes.typeText}>{planType}</p>
        <div className={`progress mt-4 ${classes.progressBar}`}>
          <div
            className={`progress-bar ${classes.progressBarFill}`}
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>
  );
};

const DocumentBoard = ({ type = "incoming" }) => {
  const [columns, setColumns] = useState([
    // {
    //   title: "Backlog",
    //   colorClass: classes.backlog,
    //   items: [],
    // },
    {
      title: "Submitted",
      colorClass: classes.submitted,
      items: [],
    },
    // {
    //   title: "Rejected",
    //   colorClass: classes.rejected,
    //   items: [],
    // },
    // {
    //   title: "Approved",
    //   colorClass: classes.approved,
    //   items: [],
    // },
  ]);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const token = localStorage.getItem("formioToken");

  const payload = JSON.parse(localStorage.getItem("formioUser"));
  const userId = payload._id;

  console.log("GIVE ME THE TOKEN", token);

  const fetchSubmissions = async (pageNum = 1) => {
    setLoading(true);
    const endpoint =
      type === "outgoing"
        ? `${env.apiUrl}/api/submissions/owner`
        : `${env.apiUrl}/api/submissions/all`;

    try {
      const response = await axios.get(
        `${endpoint}?page=${pageNum}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newItems = response.data.submissions.map((item) => {
        const readBy = item?.read || [];
        const isNew = !readBy.includes(userId);

        return {
          title: item?.formTitle || "Document name",
          refNo: item?.formTag1 || "N/A",
          planType: "N/A",
          description: "No description provided.",
          progress: item?.progress || 0,
          link: `/activity/status/${item?._id}` || null,
          isNew,
        };
      });

      setColumns((prevColumns) =>
        prevColumns.map((col) =>
          col.title === "Submitted"
            ? { ...col, items: [...col.items, ...newItems] }
            : col
        )
      );

      setTotalCount(response.data.count);
      const totalLoaded =
        columns.find((col) => col.title === "Submitted")?.items.length || 0;
      setHasMore(totalLoaded + newItems.length < response.data.count);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubmissions(1);
  }, [type]);

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchSubmissions(nextPage);
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = date
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase(); // e.g., JUN
    const year = date.getFullYear().toString().slice(2); // get last two digits
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year} ${hours}:${minutes}`;
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div className={`container-fluid py-3 ${classes.cardWrapper}`}>
      <div className="row">
        {columns.map((col, index) => (
          <div className="col-md-12" key={index}>
            <div
              className={`mb-3 pb-3 ${classes.titleWrapper} ${col.colorClass}`}
            >
              {col.title}
            </div>
            {col.items.map((item, idx) => (
              <DocumentCard key={idx} {...item} />
            ))}
            {col.title === "Submitted" && (
              <div className="d-flex justify-content-center mt-3">
                {hasMore ? (
                  <CommonButton
                    onClick={loadMore}
                    disabled={loading}
                    text={loading ? "Loading..." : "Load More"}
                  />
                ) : (
                  <p className="text-muted mt-2">No more documents to load.</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentBoard;
